import { BaseModifier } from "./base-modifier";
export class FontAwesome extends BaseModifier {
    constructor() {
        super(".font-awesome");
    }
    initialize() {
        this.icon = $("<i>");
        $(this.input.domElement).before(this.icon);
        $(this.input.domElement).on("input", () => this.setIcon());
        this.setIcon();
    }
    setIcon() {
        this.icon.removeClass();
        this.icon.addClass(`fas fa-${this.input.value}`);
    }
    prepareValue(formData, name) {
        return new Promise((resolve) => resolve());
    }
}
